import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { API_BASE_URL as baseUrl } from 'shared/config/url';

import { paramsSerializer } from './utils';

export const gspApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: 'include',
    paramsSerializer,
  }),
  endpoints: () => ({}),
});
